import { getSession } from '../auth';
import { toast } from '../components/toast';
import { getMark, bulkMark, hoursFor } from '../lib/attendance';
import type { AttendanceStatus, Employee } from '../domain';

const EMPLOYEES: Employee[] = [];

function lastWeek(): string[] {
  const out: string[] = [];
  for (let i = 6; i >= 0; i--) { const d = new Date(); d.setDate(d.getDate() - i); out.push(d.toISOString().slice(0, 10)); }
  return out;
}

export function renderStaffAttendance(): string {
  const dates = lastWeek();
  const cols = dates.map((d) => '<div class="ag-cell ag-head">' + d.slice(5) + '</div>').join('');
  const rows = EMPLOYEES.map((e) => {
    const cells = dates.map((d) => '<div class="ag-cell" data-staff-toggle data-code="' + e.uid + '" data-date="' + d + '"><span class="ag-attend">' + getMark('employees', e.uid, d) + '</span></div>').join('');
    return '<div class="ag-row"><div class="ag-cell ag-name">' + e.name + '</div>' + cells + '<div class="ag-cell"><span class="ag-pct">—</span></div></div>';
  }).join('');
  return (
    '<div class="screen-head"><div><div class="t-eyebrow">Staff attendance</div><h1 class="t-h1">Staff attendance</h1>' +
    '<p class="t-meta">' + (EMPLOYEES.length ? EMPLOYEES.length + ' staff · last 7 days' : 'No staff records yet — they appear once you add team members.') + '</p></div>' +
    '<button id="staff-save" class="btn btn-primary">Save</button></div>' +
    '<div class="attendance-grid-wrap card"><div class="attendance-grid"><div class="ag-row ag-head-row"><div class="ag-cell ag-name"></div>' + cols + '<div class="ag-cell"></div></div>' + (rows || '<div class="empty" style="grid-column:1/-1">No staff assigned.</div>') + '</div></div>'
  );
}

export function bindStaffAttendance(): void {
  document.addEventListener('click', (e) => {
    const t = e.target as HTMLElement;
    const cell = t.closest<HTMLElement>('[data-staff-toggle]');
    if (cell && cell.dataset.code && cell.dataset.date) {
      const cur = getMark('employees', cell.dataset.code, cell.dataset.date);
      const next: AttendanceStatus = cur === 'P' ? 'A' : cur === 'A' ? 'L' : cur === 'L' ? 'HD' : 'P';
      bulkMark('employees', cell.dataset.code, [cell.dataset.date], next);
      const chip = cell.querySelector('.ag-attend');
      if (chip) chip.textContent = next;
      return;
    }
    if (t.closest('#staff-save')) {
      toast('Staff attendance saved (hours: ' + EMPLOYEES.reduce((acc, e) => acc + datesHours(e), 0) + 'h)', 'success');
    }
  });
  void getSession; void hoursFor;
}

function datesHours(e: Employee): number {
  const dates = lastWeek();
  let h = 0;
  dates.forEach((d) => { h += hoursFor(getMark('employees', e.uid, d)); });
  return h;
}
